import React, { Component } from "react";
import { Routes, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";
import LanguageSelector from './components/language-selector.component';
import i18n from './i18n';

// Login Imports
import AuthService from "./services/auth.service";

import Login from "./components/login.component";
import Register from "./components/register.component";
import ResetPassword from "./components/reset-password.component";
import Home from "./components/home.component";
import Profile from "./components/profile.component";
import BoardUser from "./components/board-user.component";
import BoardFamily from "./components/board-family.component";
import BoardModerator from "./components/board-moderator.component";
import BoardAdmin from "./components/board-admin.component";
import Overview from "./components/overview.component";
import Monthly from "./components/monthly.component";
import AddExpense from "./components/add-expense.component";
import RecurringExpense from "./components/recurring-expense.component";
import GroceryDragDrop from "./components/grocery-drag-drop.component";
import CatAssistant from "./components/cat-assistant.component";

import logo from './assets/144x144.png';

import { withRouter } from "./common/with-router";
// import AuthVerify from "./common/auth-verify";
import EventBus from "./common/EventBus";

class App extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);

    this.state = {
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
      selectedFamily: null,
      selectedLanguage: this.getCountryCode(i18n.language),
      navExpanded: false,
    };
  }

  getCountryCode(lang) {
    if (!lang) return 'GB';
    if (lang.startsWith('en')) return 'GB';
    if (lang.startsWith('es')) return 'ES';
    if (lang.startsWith('ca')) return 'ES-CT';
    return 'GB';
  }

  componentDidMount() {
    const user = AuthService.getCurrentUser();

    if (user) {
      const savedFamily = JSON.parse(localStorage.getItem("selectedFamily"));
      this.setState({
        currentUser: user,
        showModeratorBoard: user.roles.includes("ROLE_MODERATOR"),
        showAdminBoard: user.roles.includes("ROLE_ADMIN"),
        selectedFamily: savedFamily || (user.families && user.families.length > 0 ? user.families[0] : null),
      });
    }

    EventBus.on("logout", () => {
      this.logOut();
    });

    this.languageChangedListener = () => {
      this.setState({ selectedLanguage: this.getCountryCode(i18n.language) });
    };
    i18n.on('languageChanged', this.languageChangedListener);
  }

  componentWillUnmount() {
    EventBus.remove("logout");
    i18n.off('languageChanged', this.languageChangedListener);
  }

  logOut() {
    
    AuthService.logout();
    this.setState({
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
      selectedFamily: null,
      navExpanded: false,
    });
    localStorage.removeItem("selectedFamily");
  }

  collapseNavbar = () => {
    this.setState({ navExpanded: false });
  };

  handleFamilySelect = (family) => {
    this.setState({ selectedFamily: family, navExpanded: false });
    localStorage.setItem("selectedFamily", JSON.stringify(family));
    this.props.router.navigate("/home");
  };

  handleLanguageSelect = (countryCode) => {
    const languageMap = {
      'GB': 'en',
      'ES': 'es',
      'ES-CT': 'ca'
    };
    const lang = languageMap[countryCode];
    if (lang) {
      i18n.changeLanguage(lang);
    }
  };

  render() {
    const { currentUser, showModeratorBoard, showAdminBoard, selectedFamily, navExpanded } = this.state;

    return (
      <div>
        <Navbar
          collapseOnSelect
          expand="lg"
          bg="dark"
          variant="dark"
          expanded={navExpanded}
          onToggle={(expanded) => this.setState({ navExpanded: expanded })}
        >
          <Container>
            <Navbar.Brand as={Link} to="/" onClick={this.collapseNavbar}>
              <img src={logo} alt="Spendcat" style={{width: "120px"}}/>
            </Navbar.Brand>
            <Navbar.Toggle id="navbar-toggle-button" aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mr-auto">
                <Nav.Link id="home-link" as={Link} to={"/home"} onClick={this.collapseNavbar}>
                  Home
                </Nav.Link>

                {/* {showModeratorBoard && (
                  <Nav.Link id="moderator-board-link" as={Link} to={"/mod"}>
                    Moderator Board
                  </Nav.Link>
                )}

                {showAdminBoard && (
                  <Nav.Link id="admin-board-link" as={Link} to={"/admin"}>
                    Admin Board
                  </Nav.Link>
                )}

                {currentUser && (
                  <Nav.Link id="user-link" as={Link} to={"/user"}>
                    User
                  </Nav.Link>
                )}
                {currentUser && (
                  <Nav.Link id="families-link" as={Link} to={"/families"}>
                    Family
                  </Nav.Link>
                )} */}
                {currentUser && (
                  <Nav.Link id="overview-link" as={Link} to={"/overview"} onClick={this.collapseNavbar}>
                    Overview
                  </Nav.Link>
                )}
                {currentUser && (
                  <Nav.Link id="monthly-link" as={Link} to={"/monthly"} onClick={this.collapseNavbar}>
                    Monthly
                  </Nav.Link>
                )}
                {currentUser && (
                  <Nav.Link id="add-expense-link" as={Link} to={"/add-expense"} onClick={this.collapseNavbar}>
                    Add Expense
                  </Nav.Link>
                )}
                {currentUser && (
                  <Nav.Link id="recurring-expenses-link" as={Link} to={"/recurring-expenses"} onClick={this.collapseNavbar}>
                    Recurring
                  </Nav.Link>
                )}
                {currentUser && (
                  <Nav.Link id="grocery-organizer-link" as={Link} to={"/grocery-organizer"} onClick={this.collapseNavbar}>
                    Grocery Organizer
                  </Nav.Link>
                )}
                {/*currentUser && (
                  <Nav.Link id="test-notifications-link" as={Link} to={"/test-notifications"}>
                    🔔 Test
                  </Nav.Link>
                )} */}
              </Nav>
              <Nav className="ms-auto">
                {currentUser ? (
                  <>
                    {currentUser.families && currentUser.families.length > 0 ? (
                      <NavDropdown
                        title={selectedFamily ? selectedFamily.name : "Family"}
                        id="family-nav-dropdown"
                      >
                        {currentUser.families.map((family, index) => (
                          <NavDropdown.Item
                            key={index}
                            onClick={() => this.handleFamilySelect(family)}
                          >
                            {family.name}
                          </NavDropdown.Item>
                        ))}
                        <NavDropdown.Divider />
                        <NavDropdown.Item as={Link} to={"/families"} onClick={this.collapseNavbar}>
                          Manage Families
                        </NavDropdown.Item>
                      </NavDropdown>
                    ) : (
                      <Nav.Link id="no-family-link" as={Link} to={"/families"} onClick={this.collapseNavbar}>
                        No Family
                      </Nav.Link>
                    )}
                    <Nav.Link id="profile-link" as={Link} to={"/profile"} onClick={this.collapseNavbar}>
                      {currentUser.username}
                    </Nav.Link>
                    <Nav.Link id="logout-link" as={Link} to={"/login"} onClick={this.logOut}>
                      LogOut
                    </Nav.Link>
                  </>
                ) : (
                  <>
                    <Nav.Link id="login-link" as={Link} to={"/login"} onClick={this.collapseNavbar}>
                      Login
                    </Nav.Link>
                    <Nav.Link id="register-link" as={Link} to={"/register"} onClick={this.collapseNavbar}>
                      Sign Up
                    </Nav.Link>
                  </>
                )}
                <div className="d-flex align-items-center ms-2">
                  <LanguageSelector
                    selected={this.state.selectedLanguage}
                    onSelect={this.handleLanguageSelect}
                  />
                </div>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <div className="container mt-3">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/user" element={<BoardUser />} />
            <Route path="/families" element={<BoardFamily />} />
            <Route path="/overview" element={<Overview />} />
            <Route path="/monthly" element={<Monthly />} />
            <Route path="/add-expense" element={<AddExpense selectedFamily={selectedFamily} />} />
            <Route path="/recurring-expenses" element={<RecurringExpense />} />
            <Route path="/grocery-organizer" element={<GroceryDragDrop />} />
            <Route path="/mod" element={<BoardModerator />} />
            <Route path="/admin" element={<BoardAdmin />} />
          </Routes>
        </div>

        <CatAssistant />

        {/* <AuthVerify logOut={this.logOut}/> */}
      </div>
    );
  }
}

export default withRouter(App);
